/**
 * Public verify page for a Quality Data Package (the QR on the cover). CR-2026-QDP (2026-10-14).
 * No login. Shows only: package number, revision, Current or Superseded, issued date, fingerprint, and (CR-2026-QDP-PDF)
 * the SHA-256 of the issued PDF file so a recipient can check the file they hold.
 */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { Alert, Box, Container, Typography } from "@mui/material";
import ApiCall from "../../utils/apicall";

export default function QdpVerify() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    ApiCall.get(`/qdp-verify/${encodeURIComponent(token || "")}`).then((r) => setData(r.data.data))
      .catch((e) => setErr(e?.response?.data?.message || "This link could not be checked."));
  }, [token]);
  return (
    <>
      <Helmet><title>Verify quality data package | SFM</title></Helmet>
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Typography variant="h4" gutterBottom>Quality data package check</Typography>
        {err && <Alert severity="error">{err}</Alert>}
        {data && (
          <Box>
            <Alert severity={data.status === "CURRENT" ? "success" : "warning"} sx={{ mb: 2 }}>
              {data.status === "CURRENT" ? "This is the current revision." : `This revision is superseded${data.supersededBy ? ` by Rev ${data.supersededBy.revision} (issued ${String(data.supersededBy.issuedAt).slice(0, 10)})` : ""}. Ask the fabricator for the current package.`}
            </Alert>
            <Typography>Package: <strong>{data.number} Rev {data.revision}</strong></Typography>
            <Typography>Issued: <strong>{String(data.issuedAt).slice(0, 10)}</strong></Typography>
            <Typography sx={{ wordBreak: "break-all" }}>Fingerprint (SHA-256): <code>{data.fingerprint}</code></Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Compare the first 12 characters with the footer of your copy. If they differ, your copy is not this package.
            </Typography>
            {(data.pdfFiles || []).length > 0 && (
              <>
                {data.pdfFiles.map((f) => <Typography key={f.sha256} sx={{ wordBreak: "break-all", mt: 2 }}>Issued PDF file (SHA-256): <code>{f.sha256}</code></Typography>)}
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  To check a PDF you received, compute its SHA-256 and compare it with the value above. On a Mac: shasum -a 256 file.pdf. On Windows: certutil -hashfile file.pdf SHA256. If they differ, the file was changed after it was issued.
                </Typography>
              </>
            )}
          </Box>
        )}
      </Container>
    </>
  );
}
